const config = {
    infinite: true,
    placeFocusBack: false,
};

export default config;
